import * as React from "react";
import { Badge } from "components/bootstrap";
const FilterStatusCell = ({ filterOutputRule }) => {
  const isEnabled = filterOutputRule.status === "enabled";
  const title = isEnabled ? "Enabled" : "Disabled";
  return /* @__PURE__ */ React.createElement(Badge, { color: isEnabled ? "success" : "warning", variant: "light", title, "aria-label": title }, title);
};
export default FilterStatusCell;
